import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

/*
https://codesandbox.io/s/react-bootstrapp-checkbox-dropdown-entcq?from-embed=&file=/src/CheckboxDropdown.js
*/



class Popup extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.state.show = false;
	}

	getChildrenByIndex(index) {
		return React.Children.toArray(this.props.children)[index];
	}

	getChildrenOfType(type) {
		let node = React.Children.toArray(this.props.children).find((child) => {
			return child.type === type;
		});

		if (node && node.props && node.props.children) {
			return node.props.children;
		}
	}

	getTrigger() {
		let trigger = this.getChildrenOfType(Popup.Trigger);

		if (!trigger) {
			trigger = this.getChildrenByIndex(0);
		}

		return trigger;
	}

	getOverlay() {
		let overlay = this.getChildrenOfType(Popup.Overlay);

		if (!overlay) {
			overlay = this.getChildrenByIndex(1);
		}

		return overlay;
	}

	show(value) {
		this.setState({ show: value });
	}

	toggle() {
		this.show(!this.state.show);
	}

	renderOverlay(props) {

        var { arrowProps, ...props } = props;

        // Remove arrows
		arrowProps.style = { display: 'none' };
		props.arrowProps = arrowProps;

		return <Popover   {...props}>{this.getOverlay()}</Popover>;
	}

	renderTrigger() {
		return <div className='d-inline-block'>{this.getTrigger()}</div>;
	}

	render() {
		return (
			<OverlayTrigger placement={'bottom-start'} trigger={'click'} show={this.state.show} onToggle={this.toggle.bind(this)} rootClose overlay={this.renderOverlay.bind(this)}>
				{this.renderTrigger()}
			</OverlayTrigger>
		);
	}
}

Popup.Trigger = () => {};
Popup.Overlay = () => {};

export default Popup;
